import { isMobile } from '../../../Assets/configuration/index.js';

export default class SearchPagination extends HTMLElement {
  constructor() {
    super();

    if (!isMobile) {
      return;
    }

    this.currentPage = this.querySelector('[aria-current=true]');
    this.scrollElement = this.querySelector('.js-searchPagination-scroll');
    const positionLeft = this.currentPage.offsetLeft - this.currentPage.offsetWidth;

    this.scrollToLeft(this.scrollElement, positionLeft);
  }

  scrollToLeft(el, position) {
    el.scrollLeft = position;
  }
}

customElements.get('f-search-pagination') || customElements.define('f-search-pagination', SearchPagination);
